import React, { useState } from 'react'
import * as R from 'ramda';

import _ from "lodash"
import storePersist from '../../../../../../redux/storePersist';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
export default function OnboardingAddressInfoComponent ({handleFormAddressItemChange, registeredAddress}: any) {
    const statesItems = storePersist?.get("states")?.current?.items;
    const countryItems = storePersist?.get("countries")?.current?.items;
      const [
        stateValues,
        setStateValues
      ] = useState([])
      const onFilterToStates = (event: any,itemIndex: any) => {
        if (event) {
            const filterStates: any = R.filter(
              (value: any) => value.Country=== event,
              statesItems
            );
            if (filterStates.length) {
              setStateValues(filterStates);
            } else {
              setStateValues(statesItems);
            }
          } else {
            setStateValues([])
          }
      }
  return (
    <>
     { _.map(
  registeredAddress,
  (selectedAddress: any, itemIndex: any) => (
                      <div className=" py-4 border-b">
                        <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
<InputContainer
    isRequired
    label="Building_Street_Area"
    name="Building_Street_Area"
    onValueChange={(event: any, newValue: any) => {
      handleFormAddressItemChange({
        value: event.target.value,
        field: 'Building_Street_Area',
        idx: itemIndex
      });
    }}
    type="text"
    value={selectedAddress?.Building_Street_Area}
/>
<InputContainer
    isRequired
    label="Locality_Town"
    name="Locality_Town"
    onValueChange={(event: any) => {
      handleFormAddressItemChange({
        value: event.target.value,
        field: 'Locality_Town',
        idx: itemIndex
      });
    }}
    type="text"
    value={selectedAddress?.Locality_Town}
/>
<InputContainer
    isRequired
    label="City_District"
    name="City_District"
    onValueChange={(event: any) => {
      handleFormAddressItemChange({
        value: event.target.value,
        field: 'City_District',
        idx: itemIndex
      });
    }}
    type="text"
    value={selectedAddress?.City_District}
/>
<InputContainer
                    isRequired
                    label="Country Name"
                    labelField="Name"
                    list={countryItems}
                    onValueChange={(event: any, newValue: any) => {
                      onFilterToStates(event.target.value,itemIndex);
                      handleFormAddressItemChange({
                        value: event.target.value,
                        field: 'Country',
                        idx: itemIndex
                      });
                    }}
                    optionName ="Choose country"
                    type="select"
                    value={selectedAddress?.Country}
                    valueField="Name"
                />
                <InputContainer
                     label="State Name"
                     labelField="Name"
                     list={stateValues}
                     onValueChange={(event: any, newValue: any) => {
                      handleFormAddressItemChange({
                        value: event.target.value,
                        field: 'State',
                        idx: itemIndex
                      });
                     }}
 optionName ="Choose State"
                     type="select"
                     value={selectedAddress?.State}
                     valueField="Name"
                 />
                 <InputContainer
    isRequired
    label="Pin code"
    name="Pincode"
    onValueChange={(event: any) => {
      handleFormAddressItemChange({
        value: event.target.value,
        field: 'Pincode',
        idx: itemIndex
      });
    }}
    type="text"
    value={selectedAddress?.Pincode}
/>
  </div>
  </div>
  ))}
        </>
  )
}